import React, { useEffect } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { jwtDecode } from 'jwt-decode';
import toast from 'react-hot-toast';



const DnaProtectedRoute = ({ children, allowedRoles }) => {
  const location = useLocation();

  const token = sessionStorage.getItem("auth_token");
  let isAuthenticated = false;
  let userRole = null;
  let email = null;
  let isTokenExpired = false;

  if (token) {
    try {
      const decoded = jwtDecode(token);
      userRole = decoded.role;
      email = decoded.email;

      const currentTime = Math.floor(Date.now() / 1000);
      if (decoded.exp < currentTime) {
        isTokenExpired = true;
      } else {
        isAuthenticated = true;
      }
    } catch (error) {
      console.error('Error decoding token:', error);
      isAuthenticated = false;
    }
  }

  const isAuthorized = isAuthenticated && allowedRoles.includes(userRole);

  useEffect(() => {
    if (isTokenExpired) {
      toast.error('Session expired, please log in again');
      sessionStorage.removeItem("auth_token");
    } else if (isAuthenticated && !isAuthorized) {
      toast.error('You are not authorized to access this page!');
    }
  }, [isTokenExpired, isAuthenticated, isAuthorized]);

  if (!isAuthenticated || !email || isTokenExpired) {
    sessionStorage.setItem('redirectAfterLogin', location.pathname + location.search);
    return <Navigate to="/dna-home" />;
  }

  if (!isAuthorized) {
    sessionStorage.setItem('redirectAfterLogin', location.pathname + location.search);
    return <Navigate to="/dna-home" />;
  }

  return children;
};

export default DnaProtectedRoute;